import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _to_property_key } from "@swc/helpers/_/_to_property_key";
import { reduxKey } from './constants';
import { StreamType } from './types';
import { STREAM__DELETE_STREAM } from './base/actions';
import withCursorStreamReducer from './withCursor/reducer';
import withOffsetStreamReducer from './withOffset/reducer';
import { STREAM__WITH_CURSOR__INITIALIZE } from './withCursor/actions';
import { STREAM__WITH_OFFSET__INITIALIZE } from './withOffset/actions';
const defaultState = {};
const reducers = {
    [reduxKey]: (state = defaultState, action)=>{
        const { type } = action;
        const { streamId, streamType: actionStreamType } = action.payload ? action.payload : action;
        if (!streamId) {
            return state;
        }
        const { [streamId]: streamState } = state, rest = _object_without_properties(state, [
            streamId
        ].map(_to_property_key));
        if (type === STREAM__DELETE_STREAM) {
            return rest;
        }
        const streamType = actionStreamType || streamState && streamState.streamType;
        let newStreamState;
        switch(streamType){
            case StreamType.WITH_CURSOR:
                newStreamState = withCursorStreamReducer(streamState, action);
                break;
            case StreamType.WITH_OFFSET:
                newStreamState = withOffsetStreamReducer(streamState, action);
                break;
            default:
                return state;
        }
        if (newStreamState === streamState) {
            return state;
        }
        // We should only create a stream from the init action, everything else
        // should end as a noop on the store.
        if (!state[streamId] && type !== STREAM__WITH_CURSOR__INITIALIZE && type !== STREAM__WITH_OFFSET__INITIALIZE) {
            return state;
        }
        return _object_spread_props(_object_spread({}, state), {
            [streamId]: newStreamState
        });
    }
};
export default reducers;
export { reduxKey };

//# sourceMappingURL=reducers.js.map